<div class="content-wrapper">
  <div class="stack-header">
    <h5 class="stack-section-title">
      <mat-icon>memory</mat-icon>
      <span class="title-label">Información del Stack</span>
    </h5>
    <button type="button" mat-raised-button class="header-button" (click)="onRefreshClick()">
      <mat-icon class="header-button-icon">refresh</mat-icon>
    </button>
  </div>


  <hr>
  <div class="table-responsive">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z2">

      <!-- ID -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>Stack ID</th>
        <td mat-cell *matCellDef="let element">{{ element.id }}</td>
      </ng-container>

      <!-- Tipo -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Modo de Conexión</th>
        <td mat-cell *matCellDef="let element">
          <span class="type-badge"
            [ngClass]="{ 'nbiot': element.type === 'NBIOT', 'BLUETOOTH': element.type === 'BLUETOOTH' }">
            <mat-icon class="icon-type" [ngClass]="{ 
        'nbiot-icon': element.type === 'NBIOT', 
        'bluetooth-icon': element.type === 'BLUETOOTH' 
      }">
              {{ element.type === 'NBIOT' ? 'settings_input_antenna' : 'bluetooth' }}
            </mat-icon>
            {{ element.type === 'NBIOT' ? 'NBIOT' : 'Bluetooth' }}
          </span>
        </td>
      </ng-container>



      <!-- Periodo -->
      <ng-container matColumnDef="period">
        <th mat-header-cell *matHeaderCellDef>Período de Envío</th>
        <td mat-cell *matCellDef="let element">{{ element.period }} (Min.)</td>
      </ng-container>

      <!-- Voltaje -->
      <ng-container matColumnDef="voltage">
        <th mat-header-cell *matHeaderCellDef>Voltaje (mV)</th>
        <td mat-cell *matCellDef="let element">{{ element.voltage }}</td>
      </ng-container>

      <!-- RSSI -->
      <ng-container matColumnDef="rssi">
        <th mat-header-cell *matHeaderCellDef>RSSI (dBm)</th>
        <td mat-cell *matCellDef="let element">{{ element.rssi }}</td>
      </ng-container>

      <!-- Error -->
      <ng-container matColumnDef="error">
        <th mat-header-cell *matHeaderCellDef>Error ID</th>
        <td mat-cell *matCellDef="let element" [ngClass]="{ 'error-value': element.error > 0 }">
          {{ element.error }}
        </td>
      </ng-container>

      <!-- LASTDATE -->
      <ng-container matColumnDef="lastDataDate">
        <th mat-header-cell *matHeaderCellDef>Última Conexión</th>
        <td mat-cell *matCellDef="let element">{{ element.lastDataDate | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
      </ng-container>

      <!-- Encabezado y fila -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <div class="info-note warning" *ngIf="getErrorIdMessages().length > 0 && showErrorId">
      <mat-icon class="warning-icon mt-1">warning</mat-icon>
      <div class="message-content">
        <ul class="error-list">
          <li *ngFor="let err of getErrorIdMessages()">
            <span class="node-label">Error ID {{ err.code }}:</span> {{ err.message }}
          </li>
        </ul>
      </div>
      <button mat-icon-button class="close-button" (click)="dismissErrorId()">
        <mat-icon>close</mat-icon>
      </button>
    </div>



    <h5 class="form-section-title" style="margin-top: 30px;">
      <span class="title-label">Nodes Conectados</span>
    </h5>
    <div class="table-responsive">
      <table mat-table [dataSource]="nodeData" class="mat-elevation-z2">

        <ng-container matColumnDef="node">
          <th mat-header-cell *matHeaderCellDef>Node</th>
          <td mat-cell *matCellDef="let item">{{ item.node }}</td>
        </ng-container>

        <ng-container matColumnDef="softwareVersion">
          <th mat-header-cell *matHeaderCellDef>Versión</th>
          <td mat-cell *matCellDef="let item">{{ item.softwareVersion }}</td>
        </ng-container>

        <ng-container matColumnDef="hardwareId">
          <th mat-header-cell *matHeaderCellDef>Hardware ID</th>
          <td mat-cell *matCellDef="let item">{{ item.hardwareId }}</td>
        </ng-container>

        <ng-container matColumnDef="module">
          <th mat-header-cell *matHeaderCellDef>Módulo</th>
          <td mat-cell *matCellDef="let item">{{ item.module }}</td>
        </ng-container>

        <ng-container matColumnDef="sensorType">
          <th mat-header-cell *matHeaderCellDef>Tipo de Sonda</th>
          <td mat-cell *matCellDef="let item">{{ item.sensorType }}</td>
        </ng-container>

        <ng-container matColumnDef="period">
          <th mat-header-cell *matHeaderCellDef>Período de Medición</th>
          <td mat-cell *matCellDef="let item">{{ item.period }} (Seg.)</td>
        </ng-container>

        <ng-container matColumnDef="voltage">
          <th mat-header-cell *matHeaderCellDef>Voltaje (mV)</th>
          <td mat-cell *matCellDef="let item">{{ item.voltage }} </td>
        </ng-container>

        <ng-container matColumnDef="error">
          <th mat-header-cell *matHeaderCellDef>Flag Error</th>
          <td mat-cell *matCellDef="let item">{{ item.error }}</td>
        </ng-container>

        <ng-container matColumnDef="previousDataDate">
          <th mat-header-cell *matHeaderCellDef>Penúltima Medición</th>
          <td mat-cell *matCellDef="let item">{{ item.previousDataDate | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
        </ng-container>

        <ng-container matColumnDef="lastDataDate">
          <th mat-header-cell *matHeaderCellDef>Última Medición</th>
          <td mat-cell *matCellDef="let item">{{ item.lastDataDate | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Acciones</th>
          <td mat-cell *matCellDef="let item">
            <button mat-icon-button (click)="navigateToNode(item)" matTooltip="Ver gráfico">
              <mat-icon class="icon-blue">visibility</mat-icon>
            </button>
          </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="nodeColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: nodeColumns;"></tr>
      </table>

      <div class="info-note warning" *ngIf="getNodeErrorMessages().length > 0 && showFlagError">
        <mat-icon class="warning-icon mt-0">warning</mat-icon>

        <div class="message-content">
          <ng-container *ngIf="getNodeErrorMessages().length === 1">
            Se ha detectado un error en el siguiente node:
          </ng-container>
          <ng-container *ngIf="getNodeErrorMessages().length > 1">
            Se han detectado errores en los siguientes nodes:
          </ng-container>

          <ul class="error-list">
            <li *ngFor="let err of getNodeErrorMessages()">
              <span class="node-label">Node {{ err.node }}:</span> {{ err.message }}
            </li>
          </ul>
        </div>

        <button mat-icon-button class="close-button" (click)="dismissFlagError()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

    </div>


    <div class="nodo-summary-grid">
      <div *ngFor="let node of nodeData" class="nodo-card">

        <div class="sensor-info">
          <span class="node-label">NODE {{ node.node }}</span>
          <span class="fecha"><strong></strong> {{ node.lastDataDate | date: 'dd/MM/yyyy HH:mm' }}</span>
        </div>

        <div class="sensor-details">
          <span><strong> Última Medición:</strong> </span>
        </div>

        <ul class="nodo-info-list">
          <ng-container *ngFor="let key of getSensorKeys(node.lastSensorData)">
            <li *ngIf="isSensorValue(key,  node.lastSensorData.type)">
              *<strong>{{ key.charAt(0).toUpperCase() + key.slice(1) }}:</strong> {{ node.lastSensorData[key] }}
            </li>
          </ng-container>
        </ul>

      </div>
    </div>




  </div>